import styled, { css } from 'styled-components'

export const Container = styled.div`
    padding: 0.7rem;
    border: 1px solid #dadada;
    border-radius: 5px;
    opacity: 0.7;

    display: flex;
    align-items: center;

    div{
        p{
            margin-top: 0.2rem;
        }

        @media (max-width: 400px){
            font-size: 0.9rem;
        }
    }

    svg{
        color: gray;
        margin-right: 1rem;
        font-size: 2rem;
    }

    & + &{
        margin-top: 1rem;
    }

    ${props => (props.cardCouponRuleSelected === props.type) && css`
        opacity: 1;
        svg{
            color: #7A05A7;
        }
    `}

    @media (min-width: 960px){
        cursor: pointer;
    }
`